import React from 'react';
import { StatusPill } from './countEntryHelpers';

/*
  THE FLOATING COUNT BAR, rebrand step 4, 17 September 2026 (brand guide 11.9).

  64 tall, glass, 12 from the sides and the bottom of the screen: the sheet's
  status, how many of its lines have a number, and the actions on the right with
  Submit last. **It holds the buttons count entry already had**, with the same
  handlers, the same disabled states and the same dialog behind Submit; it only
  moves where they are drawn. Styles in src/styles/brand-layout.css.
*/
export default function CountBar({ status, progress, children }) {
  return (
    <div className="oh-countbar" role="region" aria-label="This count">
      <StatusPill status={status} />
      <span className="oh-countbar-progress">{progress.done} of {progress.total}</span>
      <div className="oh-countbar-actions">{children}</div>
    </div>
  );
}
